import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 30vw;
    height: 2px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 45.5%, rgba(255, 255, 255, 0.00) 100%);
    margin: 20rem auto;
    position: absolute;
    top: 0;
    z-index: 0;
`;
